// @flow
export const ArtistName = "taylor swift";

export const ModalText =
  'Search for a word or a phrase and see all the places Taylor Swift \
  has used it in her music! To search for multiple words or phrases, use \
  a comma between them. Use a * for wildcard search. Scraped data can be found \
  <a href="https://github.com/shaynak/taylor-swift-lyrics">here</a>. \
  Curious about what people are searching? See our \
  <a href="https://shaynak-taylor-swift.goatcounter.com/">analytics</a>! \
  <br><br>Lyrics will generally be updated within 24 hours of an album release. \
  <br><br>Last updated: 10/15/25. First published 12/28/20.';

// Ordered list of albums for selector - keep in sync with album map
export const ALBUMS = [
  "Taylor Swift",
  "Beautiful Eyes",
  "Fearless",
  "Speak Now",
  "Red",
  "1989",
  "reputation",
  "Lover",
  "folklore",
  "evermore",
  "Midnights",
  "The Tortured Poets Department",
  "The Life of a Showgirl",
  "Collaborations",
  "Movie Soundtracks",
  "Holiday Music"
];